import {useState} from "react"

export function _initializeInstallationId() {
    let installationId = localStorage.getItem('appfw.installationId')
    if (!installationId) {
        installationId = self.crypto.randomUUID()
        localStorage.setItem('appfw.installationId', installationId)
    }
    return installationId
}

export default function useCommons() {

    const [installationId] = useState<string>(_initializeInstallationId())

    return {
        installationId
    }
}

export function isMobileDevice() {
    // Moderne Chromium-Browser
    // (Achtung: userAgentData ist nicht in Safari/Firefox verfügbar)
    // @ts-ignore
    if (navigator.userAgentData?.mobile !== undefined) {
        // @ts-ignore
        return navigator.userAgentData.mobile;
    }

    // iPadOS meldet sich oft als "MacIntel", hat aber Touch
    const isIpadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    // Fallback für ältere Browser
    const ua = navigator.userAgent;
    const mobileUA = /Android|iPhone|iPod|iPad|IEMobile|Windows Phone/i.test(ua);

    return isIpadOS || mobileUA;
}
